import React from 'react';

import CtaWithHint from 'components/CtaWithHint';
import Hero from 'components/Hero';
import LocalizedLink from 'components/LocalizedLink';
import SiteFooter from 'components/SiteFooter';
import SiteHeader from 'components/SiteHeader';
import StickyMobileCta from 'components/StickyMobileCta';
import TrustProof from 'components/TrustProof';
import HomeModules from 'components/home/HomeModules';
import HomeOutcomes from 'components/home/HomeOutcomes';
import HomeReady from 'components/home/HomeReady';
import Video from 'components/Video';
import { useI18n } from 'i18n/I18nContext';
import background from 'static/images/background@2x.jpg';
import home from 'static/images/screenshots/home.png';

const IndexPage = () => {
  const { t } = useI18n();

  return (
    <>
      <Hero as="div" background={background} className="gb-home-hero text-white">
        <SiteHeader variant="onHero" />

        <div className="container gb-home-hero__inner">
          <div className="gb-home-hero__copy gb-hero-content">
            <h1 className="gb-home-hero__title m-0">{t('home.heroTitle')}</h1>
            <p className="gb-home-hero__subtitle m-0 gb-form-lede">{t('home.heroSubtitle')}</p>

            <div className="gb-home-hero__cta" id="gb-hero-cta-end">
              <CtaWithHint
                href="/onboard"
                buttonLabel={t('home.ctaPrimary')}
                hint={t('home.ctaPrimaryHint')}
                onDark
                trackProps={{ source: 'home_hero' }}
              />
              <TrustProof onDark className="mt-35" />
              <p className="gb-home-hero__links m-0 gb-form-lede">
                <LocalizedLink className="gb-home-hero__link" to="/for">
                  {t('home.forLink')}
                </LocalizedLink>
                <span className="gb-home-hero__dot" aria-hidden>
                  ·
                </span>
                <LocalizedLink className="gb-home-hero__link" to="/guides">
                  {t('home.guidesLink')}
                </LocalizedLink>
                <span className="gb-home-hero__dot" aria-hidden>
                  ·
                </span>
                <LocalizedLink className="gb-home-hero__link" to="/checklist">
                  {t('home.checklistLink')}
                </LocalizedLink>
              </p>
            </div>
          </div>

          <div className="gb-home-hero__media">
            <img
              className="gb-float-slow gb-home-hero__phone"
              src={home}
              alt={t('home.heroHomeAlt')}
            />
          </div>
        </div>
      </Hero>

      <main className="gb-home-main">
        <HomeOutcomes />
        <HomeModules />
        <Video />
        <HomeReady />
      </main>

      <SiteFooter />
      <StickyMobileCta showAfterId="gb-hero-cta-end" hideNearId="gb-site-footer" />
    </>
  );
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/Index.tsx